import OrbAvatar from "../../../../../shared/components/orb-avatar";
import SyIcon from "../../../../../shared/components/sy-icon";
import { getTime } from "../../../../../utils/helper";
import styleSheet from "../style.module.scss";
const NotificationCard = (props: any) => {
  const { notic, onClickNotifyCard,clearNotification } = props;
  return (
    <>
      {/* <div
        className={` ${styleSheet.notic_card} ${!notic.seen?`opacity-75 `:`opacity-25`}  text-white row m-1 py-2  my-2  rounded
       border pointer `}
      >
        <div className="col d-flex  justify-content-between mohave" onClick={()=>onClickNotifyCard(notic)}>
          <div className="d-flex">
            <OrbAvatar file={notic.usrImage} />
            <p className=" mb-0 px-2">{notic?.notice?.noticeText}</p>
          </div>

          <div className="">
    
                <p className=" mb-0 ">
            {!notic.seen &&
            <span className=" font-10  bg-success badge ">new</span>
            }
            </p>
             <p className=" font-10 mb-0 bottom-0 ">
              {getTime(notic.created_at,'DD.MM.YYYY HH:mm')}
            </p>
            
           
          </div>
        </div>
      </div> */}

      <div
        className={` ${styleSheet.notic_card} ${
          !notic.seen ? `opacity-75 ` : `opacity-25`
        }  text-white row m-1 py-1  my-2  rounded
       border pointer mohave`}
        
      >
        <div className="col-2  " onClick={() => onClickNotifyCard(notic)}>
          <OrbAvatar file={notic.notice?.usr_image} />
        </div>
        <div className="col-7 p-0" onClick={() => onClickNotifyCard(notic)}>
          <p className=" mb-0 ">{notic?.notice?.noticeText}</p>
        </div>
        <div className="col-3 p-0  d-flex flex-column align-items-end justify-content-between px-1">
   
          <SyIcon
            className="pe-1 font-15 pointer  "
            name={"close"}
            iconStyle="outlined"
            iconType="symbols"
            onClick={()=>clearNotification(notic.id)}
          />

          <p className=" font-10 mb-0 bottom-0 ">
            {getTime(notic.created_at, "DD.MM.YYYY HH:mm")}
          </p>
        </div>
      </div>
    </>
  );
};

export default NotificationCard;
